import { createStandardAction } from "typesafe-actions";

export const setLoginModalOpen = createStandardAction(
  "SET_LOGIN_MODAL_OPEN",
)<boolean>();
